import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageContainer from '../../PageContainer';
import { ActionReport } from './ActionReport';

export const ActionReportPage = ({ history }: RouteComponentProps) => {
  return (
    <PageContainer history={history}>
      <ActionReport />
    </PageContainer>
  );
};
